import { toast } from "react-toastify";

export const errorHandler = (mgs) => {
  return toast.error("⚠️​ " + mgs + "!", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
  });
};
